export default __webpack_public_path__ + "static/media/AzoSansBold.880c7458.ttf";